// Add your JS customizations here
let $ = jQuery;
jQuery(document).ready(function ($) {
	initSidecart();
	initStickyAddToCart();
	initMegaMenu();
	initUnifiedDiscountForm();
	initMobileSearch();
});

/**
 * Sidecart functionality
 */
function initSidecart() {
	// ============================
	// Open / Close sidecart
	// ============================
	$(document).on("click", "[data-cart-hide]", function (e) {
		if (e.target !== this || $(".woocommerce-checkout").length) return;
		e.preventDefault();
		e.stopPropagation();
		$(".sidecart-wrapper").hide();
	});

	$(document).on("click", "[data-cart-show]", function (e) {
		e.preventDefault();
		e.stopPropagation();
		$(".sidecart-wrapper").show();
	});

	// Also open sidecart when WooCommerce fires added_to_cart
	$(document.body).on("added_to_cart", function () {
		$(".sidecart-wrapper").show();
		$(".sidecart-wrapper__content--inner").removeClass("sidecart--updating");
	});

	// ============================
	// Sidecart item actions
	// ============================
	$(document).on(
		"change",
		".sidecart-wrapper__content--inner input.qty",
		debounce(function (e) {
			e.preventDefault();
			updateMiniCartItemQty($(this));
		}, 400)
	);

	$(document).on(
		"click",
		".sidecart-wrapper__content--inner .remove-item",
		function (e) {
			e.preventDefault();
			e.stopPropagation();
			deleteMiniCartItem($(this));
		}
	);

	$(document).on(
		"click",
		".sidecart-wrapper__content--inner .add-item",
		function (e) {
			e.preventDefault();
			e.stopPropagation();
			addMiniCartItem($(this));
		}
	);

	// ============================
	// File upload preview
	// ============================
	$(document.body).on("change", "#wau_file_addon", function (e) {
		$(".image-details").html(
			`<img id="blah" src="${e.target.result}" alt="your image" />`
		);
	});

	// ============================
	// Add to cart (single product page)
	// ============================
	$(document.body).on("click", "div.product .cart .btn", function (event) {
		// Skip if it's a file upload product or gift card
		if ($(document.body).hasClass("wau_wrapper_div")) return;
		if ($(".woocommerce_gc_giftcard_form")[0]) return;

		event.preventDefault();

		var $btn = $(this);
		var $form = $btn.parents("form");

		// Prevent double-click
		if ($btn.hasClass("is-loading") || $btn.hasClass("is-added")) return;

		// Set loading state on button
		var originalHtml = $btn.html();
		$btn
			.addClass("is-loading")
			.prop("disabled", true)
			.html('<i class="fa fa-spinner fa-spin"></i>');

		// Open sidecart immediately with loading overlay
		$(".sidecart-wrapper").show();
		$(".sidecart-wrapper__content--inner").addClass("sidecart--updating");

		// Collect form data
		var data = {};
		$form.find("[name]").each(function () {
			data[this.name] = this.value;
		});

		// Variable product
		if (data["variation_id"]) {
			data["product_id"] = data["variation_id"];
			data["add-to-cart"] = null;
		}
		// Simple product
		else {
			if (data["add-to-cart"] && !data["product_id"]) {
				data["product_id"] = data["add-to-cart"];
				data["add-to-cart"] = null;
			}
		}

		// Trigger WooCommerce event
		$(document.body).trigger("adding_to_cart", [$btn, data]);

		$.ajax({
			url: wc_add_to_cart_params.wc_ajax_url
				.toString()
				.replace("%%endpoint%%", "add_to_cart"),
			method: "POST",
			data: data,
			success: function (response) {
				if (!response || response.error === true) {
					// Error: close sidecart and reload to show WooCommerce error notice
					$(".sidecart-wrapper").hide();
					$(".sidecart-wrapper__content--inner").removeClass(
						"sidecart--updating"
					);
					window.location.reload();
					return;
				}

				if (response.error && response.product_url) {
					window.location = wc_add_to_cart_params.cart_url;
					return;
				}

				if (wc_add_to_cart_params.cart_redirect_after_add === "yes") {
					window.location = wc_add_to_cart_params.cart_url;
					return;
				}

				// Success: update button to "Added"
				$btn
					.removeClass("is-loading")
					.addClass("is-added")
					.html('<i class="fa fa-check me-2"></i> Added');

				// Reset button after 3 seconds
				setTimeout(function () {
					$btn
						.removeClass("is-added")
						.prop("disabled", false)
						.html(originalHtml);
				}, 3000);

				// Trigger WooCommerce fragment refresh + open sidecart
				$(document.body).trigger("added_to_cart", [
					response.fragments,
					response.cart_hash,
					$btn,
				]);
			},
			error: function () {
				// Network error: close sidecart and reload
				$(".sidecart-wrapper").hide();
				$(".sidecart-wrapper__content--inner").removeClass(
					"sidecart--updating"
				);
				window.location.reload();
			},
		});
	});

	// ============================
	// Add to cart (archive/loop - quick add buttons)
	// ============================
	$(document.body).on(
		"click",
		".add-to-cart-container a.ajax_add_to_cart",
		function (e) {
			var $btn = $(this);

			// Prevent double-click
			if ($btn.hasClass("is-loading")) return;

			// Set loading state
			$btn.addClass("is-loading");

			// Open sidecart with loading
			$(".sidecart-wrapper").show();
			$(".sidecart-wrapper__content--inner").addClass("sidecart--updating");
		}
	);

	// When WooCommerce loop add-to-cart completes
	$(document.body).on("added_to_cart", function (e, fragments, hash, $btn) {
		if ($btn && $btn.hasClass("is-loading")) {
			$btn.removeClass("is-loading");
		}
	});

	// ============================
	// Sidecart AJAX helpers
	// ============================
	function addMiniCartItem($addBtn) {
		var $sidecart = $(".sidecart-wrapper__content--inner");
		var productId = $addBtn.data("product_id");

		$sidecart.addClass("sidecart--updating");

		$.ajax({
			url: wc_add_to_cart_params.wc_ajax_url
				.toString()
				.replace("%%endpoint%%", "add_to_cart"),
			method: "POST",
			data: { product_id: productId },
			success: function (response) {
				$sidecart.removeClass("sidecart--updating");

				if (!response || (response.error && response.product_url)) {
					window.location.reload();
					return;
				}

				$(document.body).trigger("added_to_cart", [
					response.fragments,
					response.cart_hash,
				]);
			},
			error: function () {
				$sidecart.removeClass("sidecart--updating");
				window.location.reload();
			},
		});
	}

	function deleteMiniCartItem($deleteBtn) {
		var $sidecart = $(".sidecart-wrapper__content--inner");
		var cartItemKey = $deleteBtn.data("cart_item_key");

		$sidecart.addClass("sidecart--updating");

		$.ajax({
			url: wc_add_to_cart_params.wc_ajax_url
				.toString()
				.replace("%%endpoint%%", "remove_from_cart"),
			method: "POST",
			data: { cart_item_key: cartItemKey },
			success: function (response) {
				$sidecart.removeClass("sidecart--updating");

				if (!response || (response.error && response.product_url)) {
					window.location.reload();
					return;
				}

				$(document.body).trigger("removed_from_cart", [
					response.fragments,
					response.cart_hash,
				]);
			},
			error: function () {
				$sidecart.removeClass("sidecart--updating");
				window.location.reload();
			},
		});
	}

	function updateMiniCartItemQty($qtyInput) {
		var $sidecart = $(".sidecart-wrapper__content--inner");
		var cartItemKey = $qtyInput.data("cart_item_key");

		$sidecart.addClass("sidecart--updating");

		$.ajax({
			url: wc_add_to_cart_params.wc_ajax_url
				.toString()
				.replace("%%endpoint%%", "shq_update_cart"),
			method: "POST",
			data: {
				quantity: $qtyInput.val(),
				cart_item_key: cartItemKey,
			},
			success: function (response) {
				$sidecart.removeClass("sidecart--updating");

				if (!response || (response.error && response.product_url)) {
					window.location.reload();
					return;
				}

				$(document.body).trigger("added_to_cart", [
					response.fragments,
					response.cart_hash,
				]);
			},
			error: function () {
				$sidecart.removeClass("sidecart--updating");
				window.location.reload();
			},
		});
	}
}

// ============================
// Unified Discount Code Form (coupons + gift cards)
// ============================
function initUnifiedDiscountForm() {
	// Get AJAX URL from whichever WC params object is available
	function getAjaxUrl(endpoint) {
		var params =
			window.wc_add_to_cart_params ||
			window.wc_checkout_params ||
			window.wc_cart_fragments_params;
		if (!params || !params.wc_ajax_url) return false;
		return params.wc_ajax_url.toString().replace("%%endpoint%%", endpoint);
	}

	// Handle apply button click
	$(document).on("click", ".blanco-discount-form__btn", function (e) {
		e.preventDefault();
		var $btn = $(this);
		var $form = $btn.closest(".blanco-discount-form");
		var $input = $form.find(".blanco-discount-form__input");
		var $notices = $form.find(".blanco-discount-form__notices");
		var code = $input.val().trim();
		var context = $btn.data("context");
		var gcNonce = $btn.data("gc-nonce") || "";

		if (!code) {
			$notices.html(
				'<div class="blanco-discount-notice blanco-discount-notice--error">Please enter a code.</div>'
			);
			return;
		}

		var ajaxUrl = getAjaxUrl("blanco_apply_discount");
		if (!ajaxUrl) return;

		$btn
			.prop("disabled", true)
			.html('<i class="fa fa-spinner fa-spin"></i>');
		$notices.html("");

		$.ajax({
			url: ajaxUrl,
			method: "POST",
			data: {
				code: code,
				gc_nonce: gcNonce,
				context: context,
			},
			success: function (response) {
				$btn.prop("disabled", false).html("Apply");
				if (response.result === "success") {
					$input.val("");
					$notices.html(
						'<div class="blanco-discount-notice blanco-discount-notice--success">' +
							(response.message || "Code applied successfully!") +
							"</div>"
					);
					// Refresh page fragments
					if (context === "checkout") {
						$(document.body).trigger("update_checkout");
					} else if (context === "cart") {
						window.location.reload();
					} else {
						// Sidecart: refresh fragments
						$.ajax({
							url: getAjaxUrl("get_refreshed_fragments"),
							method: "POST",
							success: function (data) {
								if (data && data.fragments) {
									$.each(data.fragments, function (key, value) {
										$(key).replaceWith(value);
									});
								}
							},
						});
					}
				} else {
					$notices.html(
						'<div class="blanco-discount-notice blanco-discount-notice--error">' +
							(response.message || "Invalid code.") +
							"</div>"
					);
				}
			},
			error: function () {
				$btn.prop("disabled", false).html("Apply");
				$notices.html(
					'<div class="blanco-discount-notice blanco-discount-notice--error">Something went wrong. Please try again.</div>'
				);
			},
		});
	});

	// Handle enter key in input
	$(document).on("keypress", ".blanco-discount-form__input", function (e) {
		if (e.which === 13) {
			e.preventDefault();
			$(this)
				.closest(".blanco-discount-form")
				.find(".blanco-discount-form__btn")
				.trigger("click");
		}
	});

	// Handle remove coupon in sidecart
	$(document).on("click", ".blanco-active-coupon__remove", function (e) {
		e.preventDefault();
		var $coupon = $(this).closest(".blanco-active-coupon");
		var couponCode = $(this).data("coupon");

		$coupon.css("opacity", "0.5");

		$.ajax({
			url: getAjaxUrl("blanco_remove_coupon"),
			method: "POST",
			data: {
				coupon: couponCode,
			},
			success: function (data) {
				if (data && data.fragments) {
					$.each(data.fragments, function (key, value) {
						$(key).replaceWith(value);
					});
				}
				// Also update checkout if on checkout page
				$(document.body).trigger("update_checkout");
			},
			error: function () {
				$coupon.css("opacity", "1");
			},
		});
	});
}

// ============================
// Sticky Add to Cart Bar (single product page)
// ============================
function initStickyAddToCart() {
	var $stickyBar = $("#sticky-atc");
	// Find the add to cart button - could be .single_add_to_cart_button or form.cart .btn
	var $addToCartBtn = $(".single_add_to_cart_button, form.cart button[type='submit'], .woocommerce-variation-add-to-cart .btn").first();

	if (!$stickyBar.length || !$addToCartBtn.length) return;

	// When the sticky bar CTA is clicked, trigger the real add-to-cart button
	$stickyBar.on("click", ".sticky-atc__btn", function (e) {
		e.preventDefault();
		// Click the actual add to cart button on the page
		$addToCartBtn.trigger("click");
	});

	// Show/hide based on scroll position, add body padding to compensate
	var barHeight = $stickyBar.outerHeight() || 60;

	var observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					$stickyBar.removeClass("is-visible");
					$stickyBar.attr("aria-hidden", "true");
					$("body").css("padding-bottom", "");
				} else {
					$stickyBar.addClass("is-visible");
					$stickyBar.attr("aria-hidden", "false");
					$("body").css("padding-bottom", barHeight + "px");
				}
			});
		},
		{ threshold: 0, rootMargin: "-80px 0px 0px 0px" }
	);

	observer.observe($addToCartBtn[0]);
}

// ============================
// Mobile Search Overlay
// ============================
function initMobileSearch() {
	var $overlay = $("#mobile-search-overlay");
	var $input = $overlay.find(".mobile-search-overlay__input");
	var $toggle = $("#mobile-search-toggle");

	if (!$overlay.length || !$toggle.length) return;

	$toggle.on("click", function (e) {
		e.preventDefault();
		$overlay.addClass("is-open");
		$overlay.attr("aria-hidden", "false");
		$("body").css("overflow", "hidden");
		setTimeout(function () {
			$input.focus();
		}, 100);
	});

	$overlay.find(".mobile-search-overlay__close").on("click", function () {
		$overlay.removeClass("is-open");
		$overlay.attr("aria-hidden", "true");
		$("body").css("overflow", "");
		$input.val("");
	});

	$(document).on("keydown", function (e) {
		if (e.key === "Escape" && $overlay.hasClass("is-open")) {
			$overlay.find(".mobile-search-overlay__close").trigger("click");
		}
	});
}

// ============================
// Utility: debounce
// ============================
function debounce(func, wait) {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		clearTimeout(timeout);
		timeout = setTimeout(function () {
			func.apply(context, args);
		}, wait);
	};
}

// ============================
// Mega Menu — hover/click panels
// ============================
function initMegaMenu() {
	var $nav = $("#mega-nav");
	if (!$nav.length) return;

	var $items = $nav.find(".mega-nav__item--has-panel");
	var $wrapper = $("#mega-panel-wrapper");
	var $backdrop = $("#mega-nav-backdrop");
	var closeTimer = null;
	var CLOSE_DELAY = 200;

	function openPanel(panelId) {
		clearTimeout(closeTimer);

		// Hide all panels, show the target
		$nav.find(".mega-panel").removeClass("mega-panel--open");
		$items.removeClass("mega-nav__item--active");

		var $panel = $("#mega-panel-" + panelId);
		var $item = $nav.find('[data-panel="' + panelId + '"]');

		if ($panel.length) {
			$wrapper.addClass("mega-panel-wrapper--open");
			$backdrop.addClass("mega-nav-backdrop--open");
			$panel.addClass("mega-panel--open");
			$item.addClass("mega-nav__item--active");
		}
	}

	function closeAll() {
		closeTimer = setTimeout(function () {
			$nav.find(".mega-panel").removeClass("mega-panel--open");
			$items.removeClass("mega-nav__item--active");
			$wrapper.removeClass("mega-panel-wrapper--open");
			$backdrop.removeClass("mega-nav-backdrop--open");
		}, CLOSE_DELAY);
	}

	function closeAllNow() {
		clearTimeout(closeTimer);
		$nav.find(".mega-panel").removeClass("mega-panel--open");
		$items.removeClass("mega-nav__item--active");
		$wrapper.removeClass("mega-panel-wrapper--open");
		$backdrop.removeClass("mega-nav-backdrop--open");
	}

	function cancelClose() {
		clearTimeout(closeTimer);
	}

	// Hover to open
	$items.on("mouseenter", function () {
		openPanel($(this).data("panel"));
	});

	$items.on("mouseleave", function () {
		closeAll();
	});

	// Keep open when hovering the wrapper (covers all panels)
	$wrapper.on("mouseenter", function () {
		cancelClose();
	});

	$wrapper.on("mouseleave", function () {
		closeAll();
	});

	// Touch: first tap opens, second tap follows link
	$items.find("> a").on("click", function (e) {
		var $item = $(this).parent();
		if ($item.hasClass("mega-nav__item--active")) return; // follow link
		e.preventDefault();
		openPanel($item.data("panel"));
	});

	// Backdrop click closes
	$backdrop.on("click", function () {
		closeAllNow();
	});

	// ESC closes
	$(document).on("keydown", function (e) {
		if (e.key === "Escape") closeAllNow();
	});
}

// ============================
// Waypoints, slick, modals
// ============================
jQuery(document).ready(function ($) {
	if (document.getElementById("wrapper-navbar-trigger") !== null) {
		var waypoint = new Waypoint({
			element: document.getElementById("wrapper-navbar-trigger"),
			handler: function (direction) {
				if (direction === "down") {
					$("body").addClass("scrolled");
				} else {
					$("body").removeClass("scrolled");
				}
			},
		});
	}

	$("#collapseSearch").on("shown.bs.collapse", function () {
		$("html, body").animate(
			{ scrollTop: 0 },
			800,
			function () {
				document.getElementById("s").focus();
			}
		);
	});

	$(".openModal").on("click", function (e) {
		e.preventDefault();
		document.querySelector("#ctaToggler").click();
	});

	$(".homepage-slides").slick({
		infinite: true,
		arrows: false,
		dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

	$(".product_list_widget_custom").slick({
		dots: false,
		arrows: false,
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					dots: false,
					adaptiveHeight: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					adaptiveHeight: true,
					infinite: true,
					dots: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					adaptiveHeight: true,
					infinite: true,
					dots: false,
				},
			},
		],
	});

	$(".test-slides").slick({
		dots: false,
		arrows: false,
		infinite: true,
		centerMode: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					dots: false,
					adaptiveHeight: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					adaptiveHeight: true,
					infinite: true,
					dots: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					adaptiveHeight: true,
					infinite: true,
					dots: false,
				},
			},
		],
	});
});
